import { render, staticRenderFns } from "./VImgEx.vue?vue&type=template&id=791e80f0&"
import script from "./VImgEx.vue?vue&type=script&lang=js&"
export * from "./VImgEx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports